import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-multi-element-identity',
  standalone: true,
  imports: [CommonModule, RouterLink, NgOptimizedImage],
  templateUrl: './multi-element-identity.component.html',
  styleUrl: './multi-element-identity.component.scss',
})
export class MultiElementIdentityComponent {
  @Input() topSportSequence: any[] = [];
  @Input() userLoggedIn = false;

  @Output() exploreClick = new EventEmitter<void>();
  @Output() evaluateClick = new EventEmitter<void>();

  fileDirectoriesPath: string = fileDirectories.profile;

  onExploreClick(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.exploreClick.emit();
  }

  onEvaluateClick() {
    this.evaluateClick.emit();
  }

  private getElementByIndex(index: number) {
    if (!this.topSportSequence || this.topSportSequence.length <= index) {
      return null;
    }
    return this.topSportSequence[index];
  }

  getAirElement() {
    return this.getElementByIndex(2);
  }

  getEarthElement() {
    return this.getElementByIndex(1);
  }

  getSnowElement() {
    return this.getElementByIndex(0);
  }

  getWaterElement() {
    return this.getElementByIndex(4);
  }
}
